import { Loader2, Paintbrush } from "lucide-react";

export const ApplyLook = ({ players, value, onPick, onApply, busy, pulse }) => (
  <div className="space-y-3 border-2 border-red-600 bg-red-50 p-4" data-testid="squad-apply-look">
    <div className="font-display text-base font-extrabold uppercase text-red-700">Set your club look</div>
    <ol className="list-decimal space-y-1 pl-4 text-xs text-slate-700">
      <li>Every player starts with a default design. Tap <strong>Edit</strong> on any player and design their shield – background, colours, crest and flag.</li>
      <li>Come back here, pick that player and tap <strong>Apply look to squad</strong>. Names, photos and stats stay.</li>
    </ol>
    <label className="block text-xs font-bold" htmlFor="look-source">Copy the look from</label>
    <select id="look-source" value={value} onChange={(e) => onPick(e.target.value)} data-testid="squad-look-source-select"
      className="w-full border-2 border-slate-200 bg-white px-3 py-2 text-sm font-semibold outline-none focus:border-slate-900">
      {players.map((p) => <option key={p.id} value={p.id}>{p.title}</option>)}
    </select>
    <button type="button" onClick={onApply} disabled={busy} data-testid="squad-apply-look-button" data-pulse={pulse}
      className={`flex w-full items-center justify-center gap-2 bg-red-600 px-4 py-3 text-sm font-extrabold uppercase tracking-wide text-white transition-colors hover:bg-red-700 disabled:opacity-60 ${pulse && !busy ? "animate-[pulseRed_1.6s_ease-in-out_infinite]" : ""}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Paintbrush className="h-4 w-4" />} Apply look to squad
    </button>
  </div>
);
